import { EpimsBaseEntityDto } from './epim-base.dto';
export class SupervisorDto extends EpimsBaseEntityDto   {
    StaffId: string;
    LevelId: string;
    StaffName: string;
    LevelName: string;
    Status: string;
    UnbehalfId: string;
    UnbehalfName: string;
    ProgramId: string;
    OMLId: string;
    SwathId: string;
    NoOfApproval: number;
    LevelPriority: number;
    Email: string;
}